import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { NgModule, Injector, ErrorHandler } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { StorageServiceModule } from 'ngx-webstorage-service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from '@src/app/app-routing.module';
import { AppComponent } from '@src/app/app.component';
import { ApiModule } from '@src/app/api/api.module';
import { environment } from '@src/environments/environment';
import { Configuration, ConfigurationParameters } from '@src/app/api/configuration';
import { ServiceWorkerModule } from '@angular/service-worker';

// Modules
// Core Module
import { CoreModule } from '@src/app/modules/core/core.module';
// Challenges Shared Module
import { IndexBannerComponent } from '@src/app/modules/core/components/index-banner/index-banner.component';
import { IndexComponent } from '@src/app/modules/core/components/index/index.component';
//import { AutoGeneratedComponent } from '@src/app/auto-generated/auto-generated.component';
import { TransferHttpCacheModule } from '@nguniversal/common';
import { CustomErrorHandlerService, ERROR_WRAPPER } from '@src/app/modules/core/services/custom-error-handler.service';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

export function apiConfigFactory(): Configuration {
  const params: ConfigurationParameters = {
    apiKeys: null,
    basePath: environment.baseApiUrl,
    withCredentials: environment.withCredentials,
  };

  return new Configuration(params);
}

@NgModule({
  declarations: [AppComponent, IndexComponent, IndexBannerComponent],
  imports: [
    BrowserModule,
    CommonModule,
    TransferHttpCacheModule,
    CoreModule,
    NgbModule,
    ApiModule.forRoot(apiConfigFactory),
    ServiceWorkerModule.register('/custom-service-worker.js', { enabled: environment.production }),
    HttpClientModule,
    AppRoutingModule,
    // Anything that gets added below should be added to the top block and sorted
  ],
  providers: [
    provideClientHydration(),
    CookieService,
    StorageServiceModule,
    { provide: 'app', useValue: 'app-b' },
    {
      provide: ErrorHandler,
      useClass: CustomErrorHandlerService,
    },
    {
      provide: ERROR_WRAPPER,
      useValue: null,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private injector: Injector) {}
}
